import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

export type ManualValidationQueryCode = {
  fieldglassId: string;
  activityItemCode: string;
  subscriptionId: string;
  zIdentifier: string;
  roles: string[];
  reasonForRejection?: string;
  manualValidationValue: string;
  validationExpirationDate?: Date;
};

const fetchManualValidation = async (payload: ManualValidationQueryCode) => {
  const { data } = await apiInputService.post(
    "manual-validation/departament",
    payload,
  );

  return data;
};

export const useManualValidation = (options?: any) => {
  return useMutation(fetchManualValidation, {
    ...options,
  });
};
